import DOMPurify from 'dompurify';

export default function sanitizeText(message) {
  return DOMPurify.sanitize(message, {
    USE_PROFILES: {
      html: false,
      mathMl: false,
      svg: false,
    },
  });
}
